import { render } from "./AddSong.vue?vue&type=template&id=5d86a819&scoped=true&ts=true"
import script from "./AddSong.vue?vue&type=script&lang=ts"
export * from "./AddSong.vue?vue&type=script&lang=ts"

import "./AddSong.vue?vue&type=style&index=0&id=5d86a819&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Roshaw\\WebstormProjects\\random-song\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d86a819"]])

export default __exports__